import type { PropsOf } from '@emotion/react'
import type { FC } from 'react'
import { useParams } from 'react-router-dom'

import Show from '@app/pages/strategies/components/aiChat/show'

type Props = Omit<PropsOf<typeof Show>, 'chatId' | 'strategyId' | 'chattableType' | 'chattableId'>

const RoutedShow: FC<Props> = (props) => {
  const { chatId, strategyId } = useParams()

  return <Show chatId={chatId} strategyId={strategyId} chattableId={strategyId} chattableType="strategy" {...props} />
}

export default RoutedShow
